import type { HTMLAttributes } from "react";
import { tv } from "tailwind-variants";

import { useFormField } from "./use-form-field";

export function FormDescription({
  ref,
  className,
  ...props
}: HTMLAttributes<HTMLParagraphElement> & { ref?: React.RefObject<HTMLParagraphElement | null> }) {
  const { formDescriptionId } = useFormField();

  return (
    <p
      ref={ref}
      id={formDescriptionId}
      className={tv({ base: "text-muted-foreground text-sm" })({ className })}
      {...props}
    />
  );
}
FormDescription.displayName = "FormDescription";
